import React from 'react';
import type { CTAData } from 'types/websiteBuilder';
import { ABRASOFT_HUB_URL } from 'utils/constants';
import styles from './CTASection.module.scss';

interface CTASectionEditorProps {
  data: Record<string, unknown>;
  onUpdateData: (data: Record<string, unknown>) => void;
}

const DEFAULT_CTA_DATA = {
  title: 'Ready to get started?',
  description: 'Join thousands of satisfied customers today.',
  buttonText: 'Sign Up Now',
};

function getData(data: Record<string, unknown>): CTAData {
  return {
    title:
      typeof data.title === 'string' && data.title.trim()
        ? data.title
        : DEFAULT_CTA_DATA.title,
    description:
      typeof data.description === 'string' && data.description.trim()
        ? data.description
        : DEFAULT_CTA_DATA.description,
    buttonText:
      typeof data.buttonText === 'string' && data.buttonText.trim()
        ? data.buttonText
        : DEFAULT_CTA_DATA.buttonText,
    buttonLink:
      typeof data.buttonLink === 'string' && data.buttonLink.trim()
        ? data.buttonLink
        : ABRASOFT_HUB_URL,
  };
}

export function CTASectionEditor({
  data,
  onUpdateData,
}: CTASectionEditorProps) {
  const update = (patch: Record<string, unknown>) => {
    onUpdateData({ ...data, ...patch });
  };

  return (
    <>
      <input
        type="text"
        className={styles.titleInput}
        value={(data.title as string) || ''}
        onChange={(e) => update({ title: e.target.value })}
        placeholder={DEFAULT_CTA_DATA.title}
      />
      <textarea
        className={styles.descInput}
        value={(data.description as string) || ''}
        onChange={(e) => update({ description: e.target.value })}
        placeholder={DEFAULT_CTA_DATA.description}
        rows={2}
      />
      <input
        type="text"
        value={(data.buttonText as string) || ''}
        onChange={(e) => update({ buttonText: e.target.value })}
        placeholder={DEFAULT_CTA_DATA.buttonText}
      />
      <input
        type="text"
        value={(data.buttonLink as string) || ''}
        onChange={(e) => update({ buttonLink: e.target.value })}
        placeholder="path or link (ex. /pagename)"
      />
    </>
  );
}

interface CTASectionProps {
  data: Record<string, unknown>;
  onUpdateData: (data: Record<string, unknown>) => void;
}

function CTASection({ data }: CTASectionProps) {
  const d = getData(data);

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <h2 className={styles.title}>{d.title}</h2>
        <p className={styles.description}>{d.description}</p>
        <a href={d.buttonLink} className={styles.cta}>
          {d.buttonText}
        </a>
      </div>
    </section>
  );
}

export default CTASection;
